module.exports = __webpack_public_path__ + "static/img/img-mchmng-placeholder.f0a9e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mchmng/img-mchmng-placeholder.png
// module id = IBGx
// module chunks = 1